import script from "./ReportsLinks.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportsLinks.vue?vue&type=script&setup=true&lang=js"

import "./ReportsLinks.vue?vue&type=style&index=0&id=1a6412c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a6412c0"]])

export default __exports__